import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApiTableColumn } from "../../types/ApiTable/ApiTableColumn";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { TableContext } from "./Context/TableContext";

interface ApiTableHeaderProps {
  column: ApiTableColumn;
}

const ApiTableHeader = ({ column }: ApiTableHeaderProps) => {
  const {
    state: { sort },
    updateSort,
  } = useContext(TableContext)!;
  const { field, label, sortable } = column;

  const handleSort = (col: ApiTableColumn) => {
    if (!col.sortable || !updateSort) return;

    if (sort && sort.field === col.field) {
      updateSort({
        field: col.field,
        direction: sort.direction === "asc" ? "desc" : "asc",
      });
    } else {
      updateSort({ field: col.field, direction: "asc" });
    }
  };

  const style = {
    ...column.style,
    cursor: sortable ? "pointer" : "default",
  };

  return (
    <th
      className={`text-white bg-primary`}
      onClick={() => handleSort(column)}
      style={style}>
      <div className="w-100 h-100 d-flex align-items-center justify-content-between">
        {label}
        <div>
          {sortable && sort && sort.field === field && (
            <FontAwesomeIcon
              className="ms-1"
              icon={sort.direction === "desc" ? faCaretDown : faCaretUp}
            />
          )}
        </div>
      </div>
    </th>
  );
};

export default ApiTableHeader;
